module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-ECsmall_1.b2f687d8.jpg";